import { useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '';

export function useGateSocket({ gateId, onEvent } = {}) {
  const socketRef = useRef(null);

  const emit = useCallback((event, data) => {
    socketRef.current?.emit(event, data);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const socket = io(SOCKET_URL, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true,
      reconnectionDelay: 2000
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      if (gateId) socket.emit('join:gate', gateId);
    });

    if (onEvent) {
      const events = [
        'session:created', 'session:status', 'session:update',
        'announcement:status', 'announcement:skipped',
        'gate:command', 'gate:online', 'gate:offline', 'gate:heartbeat',
        'gates:assigned',
        // Ad-hoc / template requests: queue placeholders change, and the
        // requester hears approved / rejected / expired (sent to their own room)
        'queue:updated', 'request:decision',
      ];
      events.forEach(evt => socket.on(evt, (data) => onEvent(evt, data)));
    }

    return () => {
      socket.disconnect();
    };
  }, [gateId]);

  return { emit };
}

export function useSupervisorSocket({ onEvent } = {}) {
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const socket = io(SOCKET_URL, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true,
      reconnectionDelay: 2000
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      socket.emit('join:supervisor');
    });

    if (onEvent) {
      const events = [
        'session:created', 'session:status',
        'announcement:status', 'announcement:skipped',
        'announcement:submitted', 'announcement:status_change',
        'gate:online', 'gate:offline', 'gate:heartbeat'
      ];
      events.forEach(evt => socket.on(evt, (data) => onEvent(evt, data)));
    }

    return () => {
      socket.disconnect();
    };
  }, []);

  return { socket: socketRef };
}
